import styles from "./Testimonial.module.css";

export const Testimonial = ({
  imageUrl,
  imageWidth,
  imageHeight,
  imageAlt,
  quotee,
  children,
}: {
  imageUrl: string;
  imageWidth: number;
  imageHeight: number;
  imageAlt: string;
  quotee: string;
  children: string;
}) => (
  <div className={styles.testimonial}>
    <img
      src={imageUrl}
      className={styles.testimonialImage}
      width={imageWidth}
      height={imageHeight}
      alt={imageAlt}
      style={{ objectFit: "cover", objectPosition: "bottom" }}
    />
    <div className={styles.testimonialQuote}>&quot;{children}&quot;</div>
    <div className={styles.testimonialQuotee}>{quotee}</div>
  </div>
);
